import axios from "@/axios/axios-config";

const getToken = () => sessionStorage.getItem("fluxus_mobile_token");

const getHeaders = (config) => {
  const token = getToken();
  return {
    Authorization: `Bearer ${token}`,
    ...config.headers,
  };
};

export const getData = async (url, config = {}) => {
  return axios.get(url, {
    ...config,
    headers: getHeaders(config),
  });
};

export const deleteData = async (url, config = {}) => {
  return axios.delete(url, {
    ...config,
    headers: getHeaders(config),
  });
};

export const postData = async (url, data, config = {}) => {
  return axios.post(url, data, {
    ...config,
    headers: getHeaders(config),
  });
};

export const putData = async (url, data, config = {}) => {
  return axios.put(url, data, {
    ...config,
    headers: getHeaders(config),
  });
};
